import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import { useDispatch } from "react-redux";

const GenericSuccessModal = (
  {
    children,
    title,
    success,
    successReset,
    rawMessage,
    secondaryAction,
    primaryAction,
    skipDispatch,
  },
  context
) => {
  const dispatch = useDispatch();

  return (
    <Modal
      isOpen={success ? true : false}
      toggle={() =>
        successReset
          ? skipDispatch
            ? successReset()
            : dispatch(successReset())
          : false
      }
    >
      <ModalHeader
        toggle={() =>
          successReset
            ? skipDispatch
              ? successReset()
              : dispatch(successReset())
            : false
        }
      >
        <span className="text-success">{title || context.t("Success!")}</span>
      </ModalHeader>
      <ModalBody>
        {children}
        {rawMessage && <pre>{rawMessage}</pre>}
      </ModalBody>
      {(primaryAction || secondaryAction) && (
        <ModalFooter>
          {secondaryAction && (
            <Button
              color="primary"
              outline
              onClick={() =>
                skipDispatch
                  ? secondaryAction?.action()
                  : dispatch(secondaryAction?.action())
              }
            >
              {secondaryAction?.title}
            </Button>
          )}
          {primaryAction && (
            <Button
              color="primary"
              onClick={() =>
                skipDispatch
                  ? primaryAction?.action()
                  : dispatch(primaryAction?.action())
              }
            >
              {primaryAction?.title}
            </Button>
          )}
        </ModalFooter>
      )}
    </Modal>
  );
};

GenericSuccessModal.propTypes = {
  success: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  successReset: PropTypes.func,
  children: PropTypes.any,
  rawMessage: PropTypes.string,
  title: PropTypes.string,
  primaryAction: PropTypes.any,
  secondaryAction: PropTypes.any,
  skipDispatch: PropTypes.bool,
};

GenericSuccessModal.defaultProps = {};

GenericSuccessModal.contextTypes = {
  t: PropTypes.func,
};

export default GenericSuccessModal;
